<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${hubId ? 'Edit' : 'Add New'} IoT Hub`" />

    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="hubId" class="custom-label">ID</label>
            <input id="hubId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label class="custom-label">Asset</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.assetid">
              <option v-for="asset in assets" :key="asset.uuid" :value="asset.uuid">{{ asset.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" rows="4" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.hubId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>
        <deleteModal v-if="this.hubId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.hubId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button" @click="addHubData()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addHub, getByIdHub, updateHub } from '@/http/hub-sensors/iot-hub.http'
import { ddAsset } from '@/http/iot-asset/asset.http'
import deleteModal from '@/components/delete-modal.vue';

export default {
  name: 'iot-hub-form',
  components: {
    Header,
    Subheader,
    deleteModal
  },
  data() {
    return {
      breadcrumsfirst: "Hub & Sensors",
      breadcrumslast: "IoT Hub",
      hubId: this.$route.params.id,
      saveData: {},
      assets: [],
    }
  },
  async mounted() {
    await this.getAssetDropdownData();
    await this.getDetailData();
  },
  methods: {
    addHubData() {
      if (this.hubId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        updateHub({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/hubsensors/iothub")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addHub(this.saveData).then(() => {
          this.$router.push("/hubsensors/iothub")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },

    async getAssetDropdownData() {
      try {
        const response = await ddAsset();
        this.assets = response;
        if (this.assets.length > 0) {
          if (this.hubId) {
            const index = this.assets.findIndex(asset => asset.uuid === this.saveData.assetid);
            if (index !== -1) {
              this.saveData.assetid = this.assets[index].uuid;
            }
          } else {
            this.saveData.assetid = this.assets[0].uuid;
          }
        }
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    },
    async getDetailData() {
      if (this.hubId) {
        try {
          const response = await getByIdHub(this.hubId);
          this.saveData = response;
          this.saveData.assetid = response.assetid;
        } catch (error) {
          console.error('Error fetching detail data:', error);
        }
      }
    },
    cancelButton() {
      this.$router.push("/hubsensors/iothub")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateHub({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/hubsensors/iothub")
      }).catch((error) => {
        this.error = error.message;
      });

    },
  }
}
</script>

<style scoped></style>